module.exports = __webpack_public_path__ + "img/product22-nongmaozhihui.879290b7.svg";